"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserDetector = void 0;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var instance = null;
var BrowserDetector = /*#__PURE__*/function () {
  function BrowserDetector() {
    var _context;
    (0, _classCallCheck2["default"])(this, BrowserDetector);
    this.isOpera = !!window.opr && !!opr.addons || !!window.opera || (0, _indexOf["default"])(_context = navigator.userAgent).call(_context, ' OPR/') >= 0;
    this.isFirefox = typeof InstallTrigger !== 'undefined';
    this.isSafari = /constructor/i.test(HTMLElement) || function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    }(!window['safari'] || typeof safari !== 'undefined' && safari.pushNotification);
    this.isIE = !!document.documentMode;
    this.isEdge = !this.isIE && !!window.StyleMedia;
    this.isChrome = !!window.chrome && (!!chrome.webstore || !!chrome.runtime);
    this.isBlink = (this.isChrome || this.isOpera) && !!CSS;
    if (instance === null) {
      instance = this;
    }
    return instance;
  }
  (0, _createClass2["default"])(BrowserDetector, [{
    key: "getBrowser",
    value: function getBrowser() {
      if (this.isOpera) {
        return 'opera';
      } else if (this.isFirefox) {
        return 'firefox';
      } else if (this.isSafari) {
        return 'safari';
      } else if (this.isIE) {
        return 'IE';
      } else if (this.isEdge) {
        return 'edge';
      } else if (this.isChrome) {
        return 'chrome';
      } else if (this.isBlink) {
        return 'blink';
      }
    }
  }], [{
    key: "getOS",
    value: function getOS() {
      var _a, _b;
      var userAgent = window.navigator.userAgent,
        platform = ((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgentData) === null || _b === void 0 ? void 0 : _b.platform) || window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;
      if ((0, _indexOf["default"])(macosPlatforms).call(macosPlatforms, platform) !== -1) {
        os = 'Mac OS';
      } else if ((0, _indexOf["default"])(iosPlatforms).call(iosPlatforms, platform) !== -1) {
        os = 'iOS';
      } else if ((0, _indexOf["default"])(windowsPlatforms).call(windowsPlatforms, platform) !== -1) {
        os = 'Windows';
      } else if (/Android/.test(userAgent)) {
        os = 'Android';
      } else if (/Linux/.test(platform)) {
        os = 'Linux';
      }
      return os;
    }
  }]);
  return BrowserDetector;
}();
exports.BrowserDetector = BrowserDetector;
//# sourceMappingURL=BrowserDetector.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/BrowserDetector.js
// module id = 1241
// module chunks = 142